
import * as React from 'react';
import { useState, useRef } from 'react'
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';


import DatePicker from "react-datepicker";
import { Row, Col } from 'react-bootstrap'
import "react-datepicker/dist/react-datepicker.css";
import TimeSlots from "./TimeSlots";
import axios from 'axios';

import { CircularProgress } from '@mui/material';

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'left',
  color: theme.palette.text.secondary,
  height: 200,
  lineHeight: '60px',
}));

const lightTheme = createTheme({ palette: { mode: 'light' } });

export default function Elevation(props) {
  const [errors, setErrors] = useState([]);
  // console.log('ele props', props)
  const user = props.user
  // console.log('bksvc', user)
  const [service, setService] = useState('')
  const [showTime, setShowTime] = useState(false)
  const [apptDate, setApptDate] = useState()
  const [apptTime, setApptTime] = useState('0:00')
  let handleServiceChange = (e) => {
    setService(e.target.value)
  }
  const [loading, setLoading] = useState(false);
  const timeSlotsRef = useRef(null);
  const [showTimeSlots, setShowTimeSlots] = useState(false);
  const setDateShowTime = () => {
    setShowTime(true)
    setTimeout(() => {
      timeSlotsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100); // small delay ensures element is mounted
  }

  const createAppointment = async (e) => {
    e.preventDefault()
    // if (apptTime === '0:00' || service === '') {
    //   alert('Please fill all the required details')
    // }

    const emailClientData = {
      "subject": 'Appointment Booking Success!',
      "name": props.clientName,
      "email": props.clientEmail,
      "start_date": startDate,
      "appt_time": apptTime,
      "service": service,
      "salon_name": props.salonName,
      "salon_phone": props.salonLandline,
      "salon_mobile": props.salonMobile,
      "message":
        "Dear " + props.clientName
        + ",\n\n"
        + "Thank you for booking your service with GroomWell Services partner. The following are the details of your appointment\n"
        + "\nAppointment Date :" + startDate
        + "\nAppointment Time : " + apptTime
        + "\nService Name: " + service
        + "\nSalon Name: " + props.salonName
        + "\nSalon Phone : " + props.salonLandline
        + "\nSalon Mobile : " + props.salonMobile
        + "\n\n"
        + "Kindly reach the salon at least 15 minutes before appointed time. For any queries please call Customer Care."
        + "\n\n"
        + "Team GroomWell"
    }
    const emailSpData = {
      "subject": 'You have new business!',
      "name": props.clientName,
      "email": props.salonEmail,
      "start_date": startDate,
      "appt_time": apptTime,
      "service": service,
      "salon_name": props.salonName,
      "salon_mobile": props.clientMobile,
      "message":
        "Dear " + props.salonName
        + ",\n\n"
        + "We are glad to inform you that one client has booked his service through us at your salon. The following are the details of your appointment\n"
        + "\nAppointment Date :" + startDate
        + "\nAppointment Time : " + apptTime
        + "\nCustomer Name : " + props.clientName
        + "\nCustomer Mobile : " + props.clientMobile
        + "\nService booked : " + service
        + "\n\n"
        + "Kindly call the customer preferably a day before and confirm the appointment. For any queries please call Customer Care."
        + "\n\n"
        + "Team GroomWell"
    }

    const appointment = {
      apptdate: startDate,
      appttime: apptTime,
      service: service,
      salon_id: props.salonId,
      status: 'confirmed',
      user_id: user.id
    }
    const missing = [];

    if (!startDate) missing.push("Appointment date");
    if (!apptTime) missing.push("Appointment time");
    if (apptTime === '0:00') missing.push("Valid Appointment time");
    if (!service) missing.push("Service");
    if (!props.salonId) missing.push("Salon ID");
    if (!user?.id) missing.push("User");

    if (missing.length > 0) {
      alert("Please provide:\n" + missing.join("\n"));
      return; // Stop form submit
    }
    const jwt = localStorage.getItem('token');
    // console.log('jwt', jwt)
    const apptUrl = (process.env.REACT_APP_SERVER
      ? `https://salonserver-k8m8.onrender.com/appointments`
      : `http://localhost:3001/appointments`)

    setLoading(true)
    try {
      const response = await axios.post(apptUrl, appointment, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": ` ${localStorage.getItem("token")} `,
        },
      });

      if (response.status === 201) {

        alert('Your appointment successfully booked')


        // Send email to client
        const jwt = localStorage.getItem('token')
        const bookingEmailsUrl = (process.env.REACT_APP_SERVER)
          ? `https://salonserver-k8m8.onrender.com/bookingmailers`
          : `http://localhost:3001/bookingmailers`


        await axios.post(bookingEmailsUrl, emailClientData, {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": ` ${localStorage.getItem("token")} `,
          },
        });

        // Send email to service provider
        const spbookingEmailsUrl = (process.env.REACT_APP_SERVER)
          ? `https://salonserver-k8m8.onrender.com/spbookingmailers`
          : `http://localhost:3001/spbookingmailers`


        await axios.post(spbookingEmailsUrl, emailSpData, {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": ` ${localStorage.getItem("token")} `,
          },
        });

        setLoading(false);

        props.setBookingVisible(false)

      }

    } catch (error) {
      if (error.response && error.response.status === 422) {
        alert(error.response.data.errors);
        setErrors(error.response.data.errors);
      } else {
        console.error("Unexpected error", error);
        setErrors(['Something went wrong. Please try again.']);
      }
      setLoading(false);
      props.setBookingVisible(false)
    }


  }

  const [startDate, setStartDate] = useState(new Date());
  return (
    <Grid container spacing={2}>
      <Grid item xs={6} >
        <ThemeProvider theme={lightTheme}>
          <Box
            sx={{
              p: 2,
              bgcolor: 'background.default',
              display: 'grid',
              gridTemplateColumns: { md: '1fr 1fr' },
              gap: 2,
            }}
          >
            <Item elevation={8}>
              <Card
                sx={{ minWidth: 275 }}
              >
                <CardContent>
                  <Typography component={'h1'} variant="h5" sx={{ mb: 1.5 }}
                  >
                    Booking Details
                  </Typography>
                  <Typography component={'h3'} sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    Salon Name : {props.salonName}
                  </Typography>
                  <Typography component={'h3'} sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    Service :
                    <select onChange={handleServiceChange}>
                      <option value="choose">
                      </option>
                      {props.services.map((service) => <option key={service.id} value={service.stype}>{service.stype}</option>)}
                    </select>
                  </Typography>
                  <Typography component={'h3'} sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    Client : {props.clientName}
                  </Typography>
                  <Typography component={'h3'} sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    Booking Date :
                    {!showTime && (
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        shouldCloseOnSelect={false}
                        onSelect={setDateShowTime}
                        z-index="1900"
                      />
                    )}
                    {
                      showTime ?
                        (
                          <div ref={timeSlotsRef}>
                            <TimeSlots
                              setApptTime={setApptTime}
                              setShowTime={setShowTime}
                              startDate={startDate}
                              salonId={props.salonId}
                              salonOpens={props.salonOpens}
                              salonCloses={props.salonCloses}
                            />
                          </div>
                        ) : null}


                  </Typography>
                  <Typography sx={{ fontSize: 14 }} color="text.secondary">
                    Booking Time : {apptTime}
                  </Typography>

                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => props.setBookingVisible(false)}
                  >Cancel</Button>
                  <Button size="small" variant="contained"
                    onClick={createAppointment}
                  >
                    {loading ? <CircularProgress size={24} color="inherit" /> : 'Confirm'}
                  </Button>
                </CardActions>
              </Card>
            </Item>
            {/* ))} */}
          </Box>
        </ThemeProvider>
      </Grid>

      {/* )} */}
    </Grid>
  );
}
